import type { ComponentProps } from 'react';

export const SliderControlLeft = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      fill='none'
      height='24'
      viewBox='0 0 24 24'
      width='24'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        clipRule='evenodd'
        d='M14.1415 5L16 6.85849L10.3585 12.5L16 18.1415L14.1415 20L6.64151 12.5L14.1415 5Z'
        fill='black'
        fillRule='evenodd'
      />
    </svg>
  );
};
